<script setup lang="ts">
import type { MenuLink } from '@/types/common'

import HeaderMenu from '@/components/Header/HeaderMenu.vue'

import logo from '@/assets/images/logo.svg'

type Props = {
  isShowNavMenu: boolean
  menuLinks: MenuLink[]
}

type Emits = {
  (fn: 'onShowSidebar'): void
}

defineProps<Props>()

const emit = defineEmits<Emits>()

const onShowSidebar = () => emit('onShowSidebar')
</script>

<template>
  <header class="header" data-test-id="header">
    <nuxt-link class="header__link" to="/" data-test-id="header-logo-link">
      <nuxt-img
        class="header__brand"
        :src="logo"
        aria-label="Перейти на главную страницу для выбора города"
        alt="Логотип компании 'FARFOR'"
        loading="eager"
        data-test-id="header-logo"
      />
    </nuxt-link>

    <header-menu
      :is-show-nav-menu="isShowNavMenu"
      :menu-links="menuLinks"
      data-test-id="header-menu"
      @on-show-sidebar="onShowSidebar"
    />
  </header>
</template>

<style scoped lang="scss">
.header {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1005;
  display: flex;
  align-items: center;
  width: 100%;
  height: 90px; // 50 - высота лого + 40 отступ сверху
  padding-top: 40px;

  &__link {
    display: flex;
  }

  &__brand {
    width: 190px;
    height: 47px;
    margin-right: 120px;
  }

  @include media('<desktop-mini') {
    justify-content: space-between;
    height: 121px; // 68 - высота лого + 53 отступ сверху
    padding: 53px 20px 0 20px;

    &__brand {
      width: 258px;
      height: 64px;
      margin-right: 0;
    }
  }

  @include media('<tablet') {
    justify-content: space-between;
    height: 60px; // 40 - высота гамбургера + 20 отступ сверху
    padding: 20px 20px 0 20px;

    &__brand {
      width: 144px;
      height: 36px;
    }
  }
}
</style>
